/**
 * Informe de auditoría de Customs AI en ventana independiente (Diego 2026-10-05):
 * ruta propia /informe-auditoria/{DO} con la sesión persistida.
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-10-05
 */
import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";
import Infaudit from "../components/Modimpxx/Customsai/Infaudit";
import { getisLoggedIn } from "../libs/redux/slices/authSlice/authSlice";

const InformeAuditoriaPage = () => {
  const { DOCNROXX } = useParams();
  const isLoggedIn = useSelector(getisLoggedIn);
  if (!isLoggedIn) {
    return <Navigate to="/" />;
  }
  return (
    <div className="inau-pagina">
      <Infaudit DOCNROXX={DOCNROXX} onVolver={() => window.close()} />
    </div>
  );
};

export default InformeAuditoriaPage;
